(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
 class StickyHeader extends HTMLElement {
 constructor() {
 super();
 }
 connectedCallback() {
 this.header = document.querySelector('.section-header');
 this.headerIsAlwaysSticky =
 this.getAttribute('data-sticky-type') === 'always' ||
 this.getAttribute('data-sticky-type') === 'reduce-logo-size';
 this.headerBounds = {};
 this.setHeaderHeight();
 window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
 if (this.headerIsAlwaysSticky) {
 this.header.classList.add('shopify-section-header-sticky');
 }
 this.currentScrollTop = 0;
 this.preventReveal = false;
 this.predictiveSearch = this.querySelector('predictive-search');
 this.onScrollHandler = this.onScroll.bind(this);
 this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
 this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
 window.addEventListener('scroll', this.onScrollHandler, false);
 this.createObserver();
 }
 setHeaderHeight() {
 document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
 }
 disconnectedCallback() {
 this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
 window.removeEventListener('scroll', this.onScrollHandler);
 }
 createObserver() {
 let observer = new IntersectionObserver((entries, observer) => {
 this.headerBounds = entries[0].intersectionRect;
 observer.disconnect();
 });
 observer.observe(this.header);
 }
 onScroll() {
 const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
 if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
 if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
 this.header.classList.add('scrolled-past-header');
 if (this.preventHide) return;
 requestAnimationFrame(this.hide.bind(this));
 } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
 this.header.classList.add('scrolled-past-header');
 if (!this.preventReveal) {
 requestAnimationFrame(this.reveal.bind(this));
 } else {
 window.clearTimeout(this.isScrolling);
 this.isScrolling = setTimeout(() => {
 this.preventReveal = false;
 }, 66);
 requestAnimationFrame(this.hide.bind(this));
 }
 } else if (scrollTop <= this.headerBounds.top) {
 this.header.classList.remove('scrolled-past-header');
 requestAnimationFrame(this.reset.bind(this));
 }
 this.currentScrollTop = scrollTop;
 }
 hide() {
 if (this.headerIsAlwaysSticky) return;
 this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
 this.closeMenuDisclosure();
 this.closeSearchModal();
 }
 reveal() {
 if (this.headerIsAlwaysSticky) return;
 this.header.classList.add('shopify-section-header-sticky', 'animate');
 this.header.classList.remove('shopify-section-header-hidden');
 }
 reset() {
 if (this.headerIsAlwaysSticky) return;
 this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
 }
 closeMenuDisclosure() {
 this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
 this.disclosures.forEach((disclosure) => disclosure.close());
 }
 closeSearchModal() {
 this.header.querySelectorAll('details-modal').forEach((modal) => modal.close(false));
 }
 }
 customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kimaia-autumn-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-autumn-purchase]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var form = root.querySelector('form');
      var variant = form.querySelector('select[name="id"]');
      var quantity = form.querySelector('[name="quantity"]');
      var total = form.querySelector('[data-autumn-total]');
      var label = form.querySelector('[data-autumn-label]');
      var money = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency', currency:root.dataset.currency || 'EUR'});
      function update() {
        var option = variant.options[variant.selectedIndex];
        var hasChoice = option && option.value !== '' && !option.disabled;
        var n = Number(quantity.value);
        var valid = quantity.validity.valid && Number.isInteger(n) && n >= 1;
        var unitPrice = Number(hasChoice ? option.dataset.price : root.dataset.basePrice);
        var value = valid ? money.format(unitPrice * n / 100) : '—';
        if (total) total.textContent = value;
        if (label) label.textContent = hasChoice ? root.dataset.addLabel : root.dataset.chooseLabel;
        var bar = document.getElementById('ksa-bar');
        if (!bar) return;
        var price = bar.querySelector('#ksa-price');
        if (price) price.textContent = value;
        var choice = bar.querySelector('.ksa-bar__choice');
        if (!choice) {
          choice = document.createElement('span');
          choice.className = 'ksa-bar__choice';
          bar.querySelector('.ksa-bar__title').after(choice);
        }
        choice.textContent = hasChoice ? (valid ? n + ' × ' : '') + option.textContent.trim() : root.dataset.chooseLabel;
        choice.hidden = false;
      }
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      document.querySelectorAll('a[href="#AutumnPurchase"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          root.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
          variant.focus({preventScroll:true});
        });
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kimaia-brand-home"] && !Shopify.designMode) return;
  try {
    
function kimaiaObserveRituals(scope) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.play().catch(() => {});
      else entry.target.pause();
    });
  }, { threshold: 0.45 });
  scope.querySelectorAll('.kh-video video').forEach(video => {
    video.muted = true;
    observer.observe(video);
  });
}
kimaiaObserveRituals(document);
document.addEventListener('shopify:section:load', event => kimaiaObserveRituals(event.target));

function kimaiaPortraitGallery(scope) {
  scope.querySelectorAll('[data-kh-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const slides = Array.from(gallery.querySelectorAll('[data-kh-slide]'));
    if (slides.length < 2) return;
    const controls = gallery.querySelector('.kh-gallery__controls');
    const toggle = gallery.querySelector('[data-kh-pause]');
    const count = gallery.querySelector('[data-kh-count]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let paused = motion.matches || Boolean(navigator.connection?.saveData);
    let visible = false;
    let timer;
    let start;
    const schedule = () => {
      clearTimeout(timer);
      if (!gallery.isConnected || paused || !visible || document.hidden || motion.matches) return;
      timer = setTimeout(() => { show(index + 1); schedule(); }, 6000);
    };
    const update = () => {
      toggle.textContent = paused ? gallery.dataset.play : gallery.dataset.pause;
      toggle.hidden = motion.matches;
      schedule();
    };
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      count.textContent = `${index + 1} / ${slides.length}`;
    };
    const manual = step => { paused = true; show(index + step); update(); };
    controls.hidden = false;
    gallery.querySelector('[data-kh-prev]').addEventListener('click', () => manual(-1));
    gallery.querySelector('[data-kh-next]').addEventListener('click', () => manual(1));
    toggle.addEventListener('click', () => { paused = !paused; update(); });
    gallery.addEventListener('focusin', () => { paused = true; update(); });
    gallery.addEventListener('mouseenter', () => clearTimeout(timer));
    gallery.addEventListener('mouseleave', schedule);
    gallery.addEventListener('pointerdown', e => { if (e.pointerType === 'touch') start = { x:e.clientX, y:e.clientY }; });
    gallery.addEventListener('pointerup', e => {
      if (!start) return;
      const dx = e.clientX - start.x;
      const dy = e.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) manual(dx < 0 ? 1 : -1);
    });
    gallery.addEventListener('pointercancel', () => { start = null; });
    document.addEventListener('visibilitychange', schedule);
    motion.addEventListener('change', () => { paused = true; update(); });
    new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      schedule();
    }, { threshold:0.3 }).observe(gallery);
    update();
  });
}
kimaiaPortraitGallery(document);
document.addEventListener('shopify:section:load', event => kimaiaPortraitGallery(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kimaia-club"] && !Shopify.designMode) return;
  try {
    
function kimaiaUnlimitedExamples(scope){scope.querySelectorAll('[data-kclub]').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';const amount=root.querySelector('[data-club-amount]'),welcome=root.querySelector('[data-club-welcome]');if(!amount||!welcome)return;function update(){const value=Math.max(0,Math.min(5000,Number(amount.value)||0));const earned=Math.floor(value),total=earned+(welcome.checked?75:0),ready=total>=100;root.querySelector('[data-club-earned]').textContent=earned;root.querySelector('[data-club-total]').textContent=total;root.querySelector('[data-club-ready]').hidden=!ready||total>=200;root.querySelector('[data-club-ready-ten]').hidden=total<200||total>=400;root.querySelector('[data-club-ready-twenty]').hidden=total<400||total>=600;root.querySelector('[data-club-ready-thirty]').hidden=total<600;root.querySelector('[data-club-wait]').hidden=ready;root.querySelector('[data-club-short]').hidden=ready;const remaining=Math.max(0,100-total);root.querySelector('[data-club-remaining]').textContent=remaining;const unit=root.querySelector('[data-club-remaining-unit]');unit.textContent=remaining===1?unit.dataset.singular:unit.dataset.plural;}amount.addEventListener('input',update);welcome.addEventListener('change',update);update();root.addEventListener('click',event=>{const link=event.target.closest('a[href^="#"]');if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;const hash=link.getAttribute('href'),target=document.getElementById(hash.slice(1));if(!target)return;event.preventDefault();if(target.tagName==='DETAILS')target.open=true;history.pushState(null,'',hash);target.setAttribute('tabindex','-1');target.focus({preventScroll:true});target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});});});}
function kimaiaUnlimitedAnchor(){const target=location.hash==='#share-products'?document.getElementById('share-products'):location.hash.startsWith('#kclub-example-')?document.getElementById(location.hash.slice(1)):null;if(target)target.open=true;}
kimaiaUnlimitedExamples(document);kimaiaUnlimitedAnchor();window.addEventListener('hashchange',kimaiaUnlimitedAnchor);document.addEventListener('shopify:section:load',event=>{kimaiaUnlimitedExamples(event.target);kimaiaUnlimitedAnchor();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kimaia-editorial-home"] && !Shopify.designMode) return;
  try {
    
function kimaiaEditorialRails(scope) {
  scope.querySelectorAll('.ke--edit').forEach(section => {
    if (section.dataset.keReady) return;
    section.dataset.keReady = 'true';
    const rail = section.querySelector('[data-ke-rail]');
    const controls = section.querySelector('[data-ke-controls]');
    const previous = section.querySelector('[data-ke-prev]');
    const next = section.querySelector('[data-ke-next]');
    if (!rail || !controls) return;
    const update = () => { previous.disabled = rail.scrollLeft < 5; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 5; controls.hidden = rail.scrollWidth <= rail.clientWidth + 5; };
    const move = direction => rail.scrollBy({left:direction * (rail.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0)),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, {passive:true}); new ResizeObserver(update).observe(rail); update();
  });
}
kimaiaEditorialRails(document);
document.addEventListener('shopify:section:load', event => kimaiaEditorialRails(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kimaia-glow-ritual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kimaia-glow-ritual')) {
  class KimaiaGlowRitual extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button || this.cleanup) return;
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.visible = false;
      this.loaded = false;
      this.userPaused = false;
      this.userStarted = false;
      this.blocked = false;
      this.pending = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      const options = { signal: this.abort.signal };
      const update = () => {
        this.toggleAttribute('data-playing', !this.video.paused);
        this.button.setAttribute('aria-label', this.video.paused ? this.dataset.play : this.dataset.pause);
      };
      this.video.addEventListener('play', update, options);
      this.video.addEventListener('pause', update, options);
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        if (!this.video.paused || this.pending) {
          this.userPaused = true;
          this.video.pause();
        } else {
          this.userPaused = false;
          this.userStarted = true;
          this.blocked = false;
          this.start();
        }
      }, options);
      this.sync = () => {
        if (!this.visible || document.hidden || this.userPaused || this.restricted()) {
          this.video.pause();
          return;
        }
        if (!this.blocked) this.start();
      };
      document.addEventListener('visibilitychange', this.sync, options);
      this.motion.addEventListener('change', this.sync, options);
      this.connection?.addEventListener?.('change', this.sync, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          this.sync();
        }, {threshold:[0, .3]});
        this.observer.observe(this);
      } else {
        this.blocked = true;
      }
      this.cleanup = () => {
        this.observer?.disconnect();
        this.abort.abort();
        this.video.pause();
      };
      update();
    }
    restricted() {
      return !this.userStarted && (this.motion.matches || this.connection?.saveData);
    }
    loadVideo() {
      if (this.loaded) return;
      const sources = Array.from(this.video.querySelectorAll('source[data-src]'));
      const limit = matchMedia('(max-width: 749px)').matches ? 1280 : 1920;
      sources.sort((a,b) => Math.max(+a.dataset.width,+a.dataset.height) - Math.max(+b.dataset.width,+b.dataset.height));
      const fitting = sources.filter(source => Math.max(+source.dataset.width,+source.dataset.height) <= limit);
      const selected = fitting.at(-1) || sources[0];
      if (!selected) return;
      this.video.src = selected.dataset.src;
      this.video.load();
      this.loaded = true;
    }
    async start() {
      if (this.pending || !this.video.paused) return;
      this.loadVideo();
      if (!this.loaded) return;
      this.pending = true;
      try {
        await this.video.play();
        if (!this.isConnected || document.hidden || this.userPaused || (!this.visible && this.observer) || this.restricted()) this.video.pause();
      } catch (error) {
        if (error.name !== 'AbortError') this.blocked = true;
      } finally {
        this.pending = false;
      }
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  }
  customElements.define('kimaia-glow-ritual', KimaiaGlowRitual);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kimaia-silk-trio"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sgt').forEach(function(root){
  var image=root.querySelector('.sgt-hero');
  var caption=root.querySelector('.sgt-caption');
  root.querySelectorAll('[data-sgt-image]').forEach(function(button){
    button.addEventListener('click',function(){
      root.querySelectorAll('[data-sgt-image]').forEach(function(other){other.setAttribute('aria-pressed','false');});
      button.setAttribute('aria-pressed','true');
      image.removeAttribute('srcset');
      image.src=button.dataset.sgtImage;
      image.alt=button.dataset.sgtAlt;
      if(caption)caption.textContent=button.dataset.sgtCaption;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nino-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kimaia-footer')) {
  customElements.define('kimaia-footer', class extends HTMLElement {
    connectedCallback() {
      this.breakpoint = window.matchMedia('(min-width: 800px)');
      this.menus = Array.from(this.querySelectorAll('.kf-menu'));
      this.syncMenus = () => this.menus.forEach(menu => {
        menu.open = this.breakpoint.matches;
        menu.querySelector('summary').tabIndex = this.breakpoint.matches ? -1 : 0;
      });
      this.keepDesktopOpen = event => {
        if (this.breakpoint.matches && event.target.matches('.kf-menu') && !event.target.open) event.target.open = true;
      };
      this.addEventListener('toggle', this.keepDesktopOpen, true);
      this.breakpoint.addEventListener('change', this.syncMenus);
      this.syncMenus();
    }
    disconnectedCallback() {
      this.breakpoint?.removeEventListener('change', this.syncMenus);
      this.removeEventListener('toggle', this.keepDesktopOpen, true);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-bundels-kimaia"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('kimaia-bundle-browser')){
 customElements.define('kimaia-bundle-browser',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.abort=new AbortController();
   const opts={signal:this.abort.signal};
   this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
   const cards=[...this.querySelectorAll('[data-kb-category]')],filters=this.querySelector('[data-kb-filters]'),status=this.querySelector('[data-kb-status]');
   this.applyFilter=value=>{
    let count=0;cards.forEach(card=>{card.hidden=!(value==='all'||card.dataset.kbCategory.split(' ').includes(value));if(!card.hidden)count++;});
    filters?.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.kbFilter===value)));
    if(status)status.textContent=count+' '+(count===1?status.dataset.singular:status.dataset.suffix);
   };
   if(filters)filters.hidden=false;if(status)status.hidden=false;this.applyFilter('all');
   this.addEventListener('click',event=>{
    const filter=event.target.closest('[data-kb-filter]');
    if(filter){this.applyFilter(filter.dataset.kbFilter);this.track('bundle_filter',{filter:filter.dataset.kbFilter});}
    const route=event.target.closest('[data-kb-route]');
    if(route){this.applyFilter('all');this.track('bundle_routine_choice',{bundle:route.dataset.kbRoute});}
    const dot=event.target.closest('[data-kb-slide]');
    if(dot){const gallery=dot.closest('[data-kb-gallery]'),track=gallery.querySelector('[data-kb-track]');track.scrollTo({left:Number(dot.dataset.kbSlide)*track.clientWidth,behavior:this.reduced.matches?'instant':'smooth'});}
    const buy=event.target.closest('[data-ks-quick]');
    if(buy){this.activeBundle=buy.closest('[data-kb-handle]')?.dataset.kbHandle;this.track('bundle_choice_click',{bundle:this.activeBundle});}
    const play=event.target.closest('[data-kb-play]');
    if(play){const video=play.parentElement.querySelector('video');if(video.paused){video.dataset.userPaused='false';this.play(video);}else{video.dataset.userPaused='true';video.pause();}}
   },opts);
   this.querySelectorAll('[data-kb-gallery]').forEach(gallery=>{
    const track=gallery.querySelector('[data-kb-track]'),buttons=[...gallery.querySelectorAll('[data-kb-slide]')],caption=gallery.querySelector('[data-kb-caption]');
    track.addEventListener('scroll',()=>{const index=Math.round(track.scrollLeft/track.clientWidth);buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));if(caption&&buttons[index])caption.textContent=buttons[index].dataset.caption;},{passive:true,...opts});
   });
   const success=this.querySelector('[data-ks-success]');
   if(success){this.successObserver=new MutationObserver(()=>{if(!success.hidden&&this.activeBundle)this.track('bundle_add_success',{bundle:this.activeBundle});});this.successObserver.observe(success,{attributes:true,attributeFilter:['hidden']});}
   this.videos=[...this.querySelectorAll('[data-kb-video]')];
   this.videos.forEach(video=>{
    const button=video.parentElement.querySelector('[data-kb-play]');
    video.addEventListener('play',()=>{button.textContent='Ⅱ';button.setAttribute('aria-label',button.dataset.pauseLabel);},opts);
    video.addEventListener('pause',()=>{button.textContent='▶';button.setAttribute('aria-label',button.dataset.playLabel);},opts);
   });
   if('IntersectionObserver' in window){
    this.videoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{entry.target.dataset.inView=String(entry.isIntersecting);if(entry.isIntersecting&&!this.reduced.matches&&!document.hidden&&entry.target.dataset.userPaused!=='true')this.play(entry.target);else entry.target.pause();}),{threshold:.4});
    this.videos.forEach(v=>this.videoObserver.observe(v));
   }
   document.addEventListener('visibilitychange',()=>this.videos.forEach(v=>{if(document.hidden)v.pause();else if(v.dataset.inView==='true'&&!this.reduced.matches&&v.dataset.userPaused!=='true')this.play(v);}),opts);
   this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.videos.forEach(v=>v.pause());},opts);
   const recordView=()=>{if(!this.viewTracked)this.viewTracked=this.track('bundle_campaign_view',{});};
   recordView();document.addEventListener('visitorConsentCollected',recordView,opts);
  }
  play(video){const source=video.querySelector('source[data-src]');if(source){source.src=source.dataset.src;source.removeAttribute('data-src');video.load();}video.muted=true;video.play().catch(()=>{});}
  track(event,details){try{if(!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())return false;const data={event,campaign:'bundles-oct18',page:location.pathname,...details};window.dataLayer=window.dataLayer||[];window.dataLayer.push(data);if(Array.isArray(window._learnq))window._learnq.push(['track',event,data]);return true;}catch(error){return false;}}
  disconnectedCallback(){this.abort?.abort();this.videoObserver?.disconnect();this.successObserver?.disconnect();this.videos?.forEach(v=>v.pause());this.ready=false;}
 });
}


  } catch(e) { console.error(e); }
})();
})();
